<div class="header-container">
  <app-detail-header-template>
    <div class="header-section" top-left>
      <div class="header-section__title">PROJECT CREATION WAS SUCCESSFUL</div>
      <div class="header-section__description">
        Here's a summary of your bulk project upload. You can use the Start New Project Upload button to get started with a new project upload.
      </div>
    </div>
  </app-detail-header-template>
</div>

<div class="bulk-project">
  <div class="list-container">

    <div class="summary-button">
      <app-button classes="secondary" class="summary-footer__button" (onClick)="viewProjects()" text="VIEW PROJECTS">
      </app-button>
      <app-button classes="secondary" class="summary-footer__button" (onClick)="startNewProjectUpload()" text="START NEW PROJECT UPLOAD">
      </app-button>
    </div>

    <div class="bulk-project__summary">
      <div class="summary-section">
        <div class="summary-body">
          <div class="summary-body__header">
            <div class="summary-body__type bold">TYPE</div>
            <div class="summary-body__details bold">DETAILS</div>
          </div>
          <div class="summary-body__content" [class.odd]="odd"
            *ngFor="let item of summaryReport; let odd = odd, let last = last, trackBy: trackByIndex">
            <div class="summary-body__type">{{item.key}}</div>
            <div class="summary-body__details">{{item.value}}</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
